import { faSignOut, faUserCog } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { VoxelPopover } from '../../../components/voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../components/voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../components/voxel/Popover/VoxelPopoverTrigger';
import VoxelMenuDivider from '../../../components/voxel/PopoverMenu/VoxelMenuDivider';
import VoxelMenuItemContainer from '../../../components/voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../../components/voxel/PopoverMenu/VoxelPopoverMenuItem';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { VoxelAvatar } from '../../../components/voxel/VoxelAvatar';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { AuthenticationContext } from '../../../logic/security/authentication/AuthenticationContext';
import { UserMenuChoices } from '../../UserPage/UserPage';

export interface StartPageUserButtonProps {
  user: CurrentUserGq;
}

export const StartPageUserButton: React.FC<StartPageUserButtonProps> = ({ user }) => {
  const history = useHistory();

  const authContext = useContext(AuthenticationContext);
  const handleSignOut = authContext.signOut;
  const [open, setOpen] = useState(false);

  return (
    <VoxelPopover enableArrow placement="bottom" onOpenChange={setOpen} open={open}>
      <VoxelPopoverTrigger>
        <button
          className={`h-full  px-2
                    flex flex-row flex-nowrap items-center gap-2
                    bg-white hover:bg-voxel-gray-50
      `}
        >
          <VoxelAvatar name={user?.email} size="md" img={user?.picture} />
          <VoxelText variant="appbar" color={open ? 'medium' : 'slight'} noWrap>
            {user?.givenName + ' ' + user?.familyName}
          </VoxelText>
        </button>
      </VoxelPopoverTrigger>
      <VoxelPopoverContent>
        {/* Avatar section */}

        <div className={'flex flex-col gap-4 justify-center items-center flex-nowrap p-6 !pb-4'}>
          <VoxelText variant={'bread-medium'} className="text-center">
            Personal account
          </VoxelText>
          {!user.picture?.length ? (
            <VoxelAvatar name={user.email} size={'xl'} />
          ) : (
            <img src={user.picture} className={'rounded-full h-16 w-16'} />
          )}
          <div className="flex flex-col gap-0 items-center">
            {!!user.givenName?.length && !!user.familyName?.length && (
              <VoxelText variant={'title3'} className="text-center">
                {user.givenName} {user.familyName}
              </VoxelText>
            )}
            <VoxelText variant={'bread-normal'} className="text-center">
              {user.email}
            </VoxelText>
          </div>
        </div>

        <VoxelMenuItemContainer size="md">
          <VoxelMenuDivider />
          <VoxelPopoverMenuItem
            onClick={() => history.push(`/user/${UserMenuChoices.DataSettings}`)}
            title="Settings"
            icon={<FontAwesomeIcon icon={faUserCog} />}
          />
          <VoxelPopoverMenuItem
            onClick={handleSignOut}
            title="Sign Out"
            icon={<FontAwesomeIcon icon={faSignOut} />}
          />
        </VoxelMenuItemContainer>
      </VoxelPopoverContent>
    </VoxelPopover>
  );
};

export default StartPageUserButton;
